import { BaseModal } from "@graffer-inc/smart-apply";
import { DuplicatePathResults } from "./custom-path-validator";
import {
  PrimaryButton,
  SecondaryButton,
} from "@graffer-inc/console-design-kit";

type CustomPathModalProps = {
  customPathDuplicateError: DuplicatePathResults;
  isActive: boolean;
  onClose: () => void;
  onUpdate: () => void;
};

export const CustomPathValidateResultModal: React.FC<CustomPathModalProps> = ({
  customPathDuplicateError,
  isActive,
  onClose,
  onUpdate,
}) => {
  return (
    <BaseModal
      title={
        customPathDuplicateError.status === "error"
          ? "指定したURLは使用できません。"
          : "他の手続きのURLを上書きしますか？"
      }
      isActive={isActive}
      onClose={onClose}
    >
      <section className="modal-card-body">
        <div
          style={{
            whiteSpace: "pre-wrap",
          }}
        >
          {customPathDuplicateError.message}
        </div>
      </section>
      <footer className="modal-card-foot columns is-centered pt-2">
        <div className="column is-narrow">
          <SecondaryButton
            text={
              customPathDuplicateError.status === "error"
                ? "閉じる"
                : "キャンセルする"
            }
            onClick={onClose}
          />
        </div>
        {customPathDuplicateError.status === "warning" && (
          <div className="column is-narrow">
            <PrimaryButton text="更新する" onClick={onUpdate} />
          </div>
        )}
      </footer>
    </BaseModal>
  );
};
